import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {Page} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/page.types';
import {OrderSuccessPageService_GetPageMetaDataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/service.grpc.lazy';
import {Head} from '@aboutyou/head-elements';
import {TrackContentPageView} from '@aboutyou/tracking';
import React, {Fragment} from 'react';
import {
  extractMetaAndLinkTags,
  isSeoData,
  setDataTestIds,
} from '../../../shared-deprecated/metaUtils';

const usePageMeta = () => {
  return useGrpcRequest(
    OrderSuccessPageService_GetPageMetaDataLazy,
    {},
    {
      mockData: async () => ({
        meta: {
          type: {
            $case: 'seoData',
            seoData: {
              title: 'Order Success',
              elements: [],
              jsonLd: [],
            },
          },
        },
      }),
    },
  );
};

export const OrderSuccessPageMeta = () => {
  return <DataFetcher request={usePageMeta()} Error={null} View={View} />;
};

const View = ({meta}: {meta: Page}) => {
  if (!isSeoData(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <Fragment>
      <TrackContentPageView pageTitle={seoData.title} />
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </Fragment>
  );
};
